export default "__VITE_ASSET__xbRvHYq8__"